import jump from 'jump.js';

const items = document.querySelectorAll('[data-scroll-to]');

items.forEach(item => {
    item.addEventListener('click', e => {
        e.preventDefault();
        let id = '#' + item.dataset.scrollTo;
        jump(id, { offset: 5 });
    });
});



// WEBPACK FOOTER //
// ./src/js/components/scroll-to-anchor.js